import { httpClient } from '@bcba/client-auth';
import { GetPaginatedSentDigitalDossierAccessRequestsDto } from './dto/getPaginatedSentDigitalDossierAccessRequests.dto';

export const getSentDigitalDossierAccessRequests = async (
  params: GetPaginatedSentDigitalDossierAccessRequestsDto,
) => {
  const { data } = await httpClient.get(
    '/digital-dossier-access-requests/sent',
    { params },
  );

  return data;
};
